import { moduleProviderFactory } from 'core/providers';
import { Dashboard, TrackingDashboard } from './pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.dashboard',
				pattern: '/dashboard',
				isPrivate: true,
				authorization: ['dashboardSection.read'],
				children: [
					{
						name: 'master.app.main.dashboard',
						pattern: '',
						component: Dashboard,
					},
				],
			},
			{
				name: 'master.app.main.tracking-dashboard',
				pattern: '/tracking-dashboard',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.tracking-dashboard',
						pattern: '',
						component: TrackingDashboard,
					},
				],
			},
		],
	});
})();
